import { render, staticRenderFns } from "./CantidadResultados.vue?vue&type=template&id=0289a965&"
import script from "./CantidadResultados.vue?vue&type=script&lang=js&"
export * from "./CantidadResultados.vue?vue&type=script&lang=js&"
import style0 from "./CantidadResultados.vue?vue&type=style&index=0&id=0289a965&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports